import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const SearchIcon = () => (
  <svg className="search-icon" viewBox="0 0 15 15" fill="none" aria-hidden="true">
    <circle cx="6.84" cy="6.84" r="5.99" stroke="currentColor" strokeOpacity="0.6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M11.01 11.32 13.36 13.67" stroke="currentColor" strokeOpacity="0.6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [search, setSearch] = useState('');
  const { user, backendUser, logout } = useAuth();
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    const q = search.trim();
    navigate(q ? `/?search=${encodeURIComponent(q)}` : '/');
    setMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo" onClick={() => setMenuOpen(false)}>Zimetafsiriwa</Link>

        <form className="search-bar" role="search" onSubmit={handleSearch}>
          <SearchIcon />
          <input
            type="search"
            className="search-input"
            placeholder="Search movies / TV Shows"
            aria-label="Search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </form>

        <div className={`navbar-links ${menuOpen ? 'active' : ''}`}>
          <Link to="/" className="nav-link" onClick={() => setMenuOpen(false)}>Home</Link>
          <Link to="/?filter=movies" className="nav-link" onClick={() => setMenuOpen(false)}>Movies</Link>
          <Link to="/?filter=series" className="nav-link" onClick={() => setMenuOpen(false)}>Series</Link>
          {process.env.NODE_ENV === 'development' && (
            <Link to="/demo" className="nav-link nav-link--demo" onClick={() => setMenuOpen(false)} style={{ color: '#ff4d4d', fontWeight: 'bold' }}>▶ Demo Player</Link>
          )}
          {backendUser?.role === 'admin' && (
            <Link to="/admin" className="nav-link" onClick={() => setMenuOpen(false)}>Admin</Link>
          )}

          <div className="navbar-auth-mobile">
            {user ? (
              <button onClick={() => { logout(); setMenuOpen(false); }} className="auth-btn auth-btn--logout">Logout</button>
            ) : (
              <Link to="/login" className="auth-btn auth-btn--login" onClick={() => setMenuOpen(false)}>Login</Link>
            )}
          </div>
        </div>

        <div className="navbar-right">
          {backendUser?.role === 'admin' && (
            <Link to="/admin" className="nav-link">Admin</Link>
          )}
          <div className="navbar-auth">
            {user ? (
              <button onClick={logout} className="auth-btn auth-btn--logout">Logout</button>
            ) : (
              <Link to="/login" className="auth-btn auth-btn--login">Login</Link>
            )}
          </div>
          <button className={`hamburger ${menuOpen ? 'active' : ''}`} onClick={() => setMenuOpen(!menuOpen)} aria-label="Menu">
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </nav>
  );
}
